import { useParams } from 'react-router-dom';
import { FeatureThemeProvider } from '../../../theme/FeatureThemeProvider.jsx';
import TemplateSingleAnalyticsView from '../components/summary/TemplateSingleAnalyticsView';

export default function TemplateDetailsPage() {
  return (
    <FeatureThemeProvider>
      <TemplateSingleAnalyticsView />
    </FeatureThemeProvider>
  );
}
